export const trimEdges = (value) => {
  if (typeof value !== "string") return value ?? "";
  return value.trim();
};
